<template>
    <div>
        <cover-image
            :src="shoot.coverImageDesktop"
            :tablet-src="shoot.coverImageTablet"
            :phone-src="shoot.coverImagePhone"
            :background-color="shoot.coverImageDesktop ? null : shoot.primaryColor"
            :color="shoot.primaryColor"
            :secondary-color="shoot.secondaryColor"
            :title="shoot.title"
            :subtitle="shoot.date"
            action-text="Bilder ansehen"
            action-path="#gallery" main left>

            <template #buttons>
                <v-btn to="/photo-shoots" :color="shoot.secondaryColor ?? undefined" size="x-large" :prepend-icon="mdiArrowLeft">
                    Alle Shootings
                </v-btn>
            </template>

            <template #description>
                <shoot-artist-list :shoot="shoot"/>
            </template>

        </cover-image>

        <gallery id="gallery" :items="shoot.images"/>

        <app-footer/>

    </div>
</template>

<script setup lang="ts">
import {type PhotoShoot} from "../../types/models/PhotoShoot";
import {mdiArrowLeft} from "@mdi/js";

const {params} = useRoute();

const {data: shoot}: {data: PhotoShoot} = await useApiFetch('getPhotoShoot', [
    'title',
    'slug',
    'date',
    'primaryColor',
    'secondaryColor',
    'coverImageDesktop',
    'coverImageTablet',
    'coverImagePhone',
    'photographArtist {name url}',
    'makeupArtist {name url}',
    'hairArtist {name url}',
    'images'
], `where: {slug: "${params.shoot}"}`);

useMeta({
    title: shoot.title,
    description: `Betrachte alle meine Fotos aus dem Shooting "${shoot.title}".`,
})

</script>